export const nextPlayerSound = new Audio(require('@/assets/sounds/next-player.wav'));
export const goToBenchSound = new Audio(require('@/assets/sounds/bench.wav'));
export const buyTeamSound = new Audio(require('@/assets/sounds/buy-person.wav'));
export const sellTeamSound = new Audio(require('@/assets/sounds/sell-person.wav'));
export const paySound = new Audio(require('@/assets/sounds/pay-somebody.mp3'));
export const getMoneySound = new Audio(require('@/assets/sounds/get-money-from-sb.wav'));
export const diceRollSound = new Audio(require('@/assets/sounds/dice-roll.wav'));
export const bonusSound = new Audio(require('@/assets/sounds/bonus.mp3'));
